import styled from "styled-components";

export const MarketContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.white};
  margin-bottom: 10px;
`;
